import { render, staticRenderFns } from "./carbonReduction.vue?vue&type=template&id=f0947b68&scoped=true&"
import script from "./carbonReduction.vue?vue&type=script&lang=js&"
export * from "./carbonReduction.vue?vue&type=script&lang=js&"
import style0 from "./carbonReduction.vue?vue&type=style&index=0&id=f0947b68&prod&lang=css&"
import style1 from "./carbonReduction.vue?vue&type=style&index=1&id=f0947b68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0947b68",
  null
  
)

export default component.exports